import { render, staticRenderFns } from "./UserBadges.vue?vue&type=template&id=028fbaae&scoped=true&"
import script from "./UserBadges.vue?vue&type=script&lang=js&"
export * from "./UserBadges.vue?vue&type=script&lang=js&"
import style0 from "./UserBadges.vue?vue&type=style&index=0&id=028fbaae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028fbaae",
  null
  
)

export default component.exports